const initState = {
    loadTrasversalServices: false,
    /**control */
    error:false,
    message:"",

};

export default initState;